import { Assets } from "../components/shared/Globals";

export const products = [
  {
    id: 1,
    title: "3500 IU (Pack of 4)",
    price: "<s>₹150</s> ₹140",
    pp: 140,
    header: "Your weekly boost of Vitamin D made delicious.",
    description: "Perfect for regular wellness and everyday energy.",
    details:
      "This variant delivers 3,500 IU of Vitamin D3 in a single, delicious piece — perfect for regular maintenance of healthy Vitamin D levels",
    img: "https://res.cloudinary.com/dgne9mq7j/image/upload/v1745755816/prod3_vrm5j1.webp",
    images: [
      "https://res.cloudinary.com/dgne9mq7j/image/upload/v1745755816/prod3_vrm5j1.webp",
      "https://res.cloudinary.com/dgne9mq7j/image/upload/v1746452212/IMG_9986_iwoq57.webp",
      "https://res.cloudinary.com/dgne9mq7j/image/upload/v1746452197/IMG_0008_1_vblsbx.webp",
      "https://res.cloudinary.com/dgne9mq7j/image/upload/v1746452194/Back_info_SKD_3500_tzh82v.webp",
      "https://res.cloudinary.com/dgne9mq7j/image/upload/v1746452191/e_1_1_yi0muh.webp",
      "https://res.cloudinary.com/dgne9mq7j/image/upload/v1746452191/IMG_0071_vhfgo6.webp",
    ],
  },
  {
    id: 2,
    title: "3500 IU Sugar-Free (Pack of 4)",
    price: "<s>₹170</s> ₹160",
    pp: 160,
    header: "Zero sugar. All the sunshine.",
    description:
      "For those who want a healthier option without compromising taste or benefits.",
    details:
      "This variant delivers 3,500 IU of Vitamin D3 in a single, delicious piece — perfect for regular maintenance of healthy Vitamin D levels",

    img: "https://res.cloudinary.com/dgne9mq7j/image/upload/v1745755815/prod4_hk8osg.webp",
    images: [
      "https://res.cloudinary.com/dgne9mq7j/image/upload/v1745755815/prod4_hk8osg.webp",
      "https://res.cloudinary.com/dgne9mq7j/image/upload/v1746452213/IMG_9985_nxqwkt.webp",
      "https://res.cloudinary.com/dgne9mq7j/image/upload/v1746452204/IMG_9883_oiopun.webp",
      "https://res.cloudinary.com/dgne9mq7j/image/upload/v1746452191/Back_info_SKD_3500_SF_jx7fyb.webp",
      Assets.IMG_0017,
      Assets.IMG_9994,
    ],
  },
  {
    id: 3,
    title: "15000 IU (Pack of 4)",
    price: "<p>Inquiry To Know</p>",
    header: "A high-strength monthly dose of Vitamin D.",
    description:
      "Specially designed for guided use under professional advice or bulk purchase needs.",
    details:
      "This variant delivers 15,000 IU of Vitamin D3 in a single, delicious piece — perfect for regular maintenance of healthy Vitamin D levels",
    img: "https://res.cloudinary.com/dgne9mq7j/image/upload/v1745755815/prod_j9cbkv.webp",
    images: [
      "https://res.cloudinary.com/dgne9mq7j/image/upload/v1745755815/prod_j9cbkv.webp",
      "https://res.cloudinary.com/dgne9mq7j/image/upload/v1746452198/IMG_9973_clfpma.webp",
      "https://res.cloudinary.com/dgne9mq7j/image/upload/v1746452194/Back_info_SKD_pages-to-jpg-0001_hu3hgg.webp",
    ],
  },
  {
    id: 4,
    title: "15000 IU Sugar-Free (Pack of 4)",
    price: "<p>Inquiry To Know</p>",
    header: "A high-strength monthly dose of Vitamin D.",
    description:
      "This higher-intensity Vitamin D chocolate is crafted for advanced needs, without added sugar.",
    details:
      "This variant delivers 15,000 IU of Vitamin D3 in a single, delicious piece — perfect for regular maintenance of healthy Vitamin D levels",

    img: "https://res.cloudinary.com/dgne9mq7j/image/upload/v1745755815/Prod2_hi9qm6.webp",
    images: [
      "https://res.cloudinary.com/dgne9mq7j/image/upload/v1745755815/Prod2_hi9qm6.webp",
      "https://res.cloudinary.com/dgne9mq7j/image/upload/v1746452196/IMG_9956_fj13fi.webp",
      "https://res.cloudinary.com/dgne9mq7j/image/upload/v1746452190/Back_info_SKD_pages-to-jpg-0002_s8xhu6.webp",
    ],
  },
];
